import React, { Fragment } from 'react';
import classNames from 'classnames';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import Button from 'src/ui/library/Button';
import intl from 'react-intl-universal';
import Add from '@material-ui/icons/Add';
import Hidden from '@material-ui/core/Hidden';
import { MESSAGEDETAIL_TYPES, MESSAGEBOX_VIEWS } from 'src/constants/constants';
import TableFilter from 'src/ui/library/TableFilter';

export default function ToolbarPres({
  detailType,
  isCaseMessages,
  isComposeView,
  isDefaultOldView,
  isDraftView,
  isMobile,
  currentView,
  composeClickedLg,
  composeClicked,
  filterConfig,
  onFilterSearch,
  onFilterApply,
  onFilterClear,
  disableNewMessage,
  pageType,
  defaultSelectedFilters,
  onFilter,
  isShowFilterOptions,
}) {
  const containerClasses = classNames('messaging-toolbar', { mobile: isMobile });
  const toolbarButtonMobileClasses = classNames('messaging-toolbar-button', {
    mobile: isMobile,
    'not-compose': detailType !== MESSAGEDETAIL_TYPES.COMPOSE,
    'case-btn': isCaseMessages,
  });
  return (
    <Grid container className={containerClasses}>
      <Hidden xsDown>
        <Fragment>
          <div className="messaging-table-filter">
            <TableFilter
              filters={filterConfig}
              pageType={pageType}
              onSearch={onFilterSearch}
              onApply={onFilterApply}
              onClear={onFilterClear}
              defaultSelectedFilters={defaultSelectedFilters}
              onFilter={onFilter}
              isShowFilterOptions={isShowFilterOptions}
            />
            <div className="messageFilterStyleBtn">
              <Button
                disabled={disableNewMessage}
                className={toolbarButtonMobileClasses}
                onClick={composeClickedLg.bind(null, MESSAGEDETAIL_TYPES.COMPOSE)}>
                <span>{intl.get('messaging.toolbar.newmessage')}</span>
              </Button>
            </div>
          </div>
        </Fragment>
      </Hidden>

      <Hidden smUp>
        {currentView === MESSAGEBOX_VIEWS.LIST && !(isComposeView || isDraftView) && (
          <Button className={toolbarButtonMobileClasses} onClick={composeClicked.bind(null, MESSAGEDETAIL_TYPES.COMPOSE)}>
            <Add className="icon lg" />
          </Button>
        )}
      </Hidden>
    </Grid>
  );
}

ToolbarPres.propTypes = {
  selectDetailView: PropTypes.func.isRequired,
};
